import React from 'react'
import { SortByType } from '../../constants'
import { useQuery } from '@apollo/client'
import { MarketingAnalytics, MarketingAnalyticsVariables, SortDirectionEnum } from '../../types'
import { MARKETING_ANALYTICS } from './operations'

interface Filters {
  memberLike?: string
}

export type Sorter = {
  sortBy?: string
  direction?: SortDirectionEnum
}

interface Props {
  filter?: Filters
  sorter?: Sorter
  page?: number
  pageLength?: number
  skip?: boolean
}

const PAGE_LENGTH = 10

export const useMarketingAnalytics = ({
  filter,
  page = 1,
  pageLength = PAGE_LENGTH,
  skip = false,
  sorter,
}: Props = {}) => {
  const { memberLike } = filter || {}
  const queryVariables = React.useMemo<MarketingAnalyticsVariables>(
    () => ({
      filterData: {
        user: memberLike ? { emailOrNameLike: memberLike } : null,
      },
      pagination: {
        from: pageLength * (page - 1),
        length: pageLength,
        sortBy: sorter?.sortBy || SortByType.ID,
        direction: sorter?.direction || SortDirectionEnum.ASC,
      },
    }),
    [memberLike, page, pageLength]
  )
  const marketingAnalyticsQuery = useQuery<MarketingAnalytics, MarketingAnalyticsVariables>(
    MARKETING_ANALYTICS,
    {
      variables: queryVariables,
      skip,
    }
  )

  return marketingAnalyticsQuery
}
